export default "__VITE_ASSET__0de44487__"